import { gql } from "@apollo/client";
import PositionFields from "../fragments/position-fragment";
import PositionWorkerFields from "../fragments/position-worker-fragment";

export default gql`
  mutation addPositionBonus($employerId: String!, $data: PositionBonusInput!) {
    addPositionBonus(data: $data) {
      ...PositionFields
      worker {
        ...PositionWorkerFields
        positionCountByEmployer(employerId: $employerId)
      }
    }
  }
  ${PositionFields}
  ${PositionWorkerFields}
`;
